import SimpleBar from 'simplebar-react';
import styled from "styled-components";
import { media, theme } from "../../theme/theme";
export const CCUnsplashScroller = styled(SimpleBar)`
    max-height: 150px;
`;

export const CCUnsplashResults = styled.div`
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 3px 12px 3px 3px;
`;

export const CCUnsplashThumb = styled.div.attrs<{ backgroundImg: string }>(
    ({ backgroundImg }) => ({
        style: {
            background: backgroundImg ? `url(${backgroundImg}) center center / cover no-repeat` : undefined,
        },
    })
) <{ backgroundImg: string, selected?: boolean }>`
    width: 100%;
    margin-bottom: 24px;
    height: 101px;
    border-radius: 10px;
    position: relative;
    box-shadow: ${({ theme, selected }) => selected ? `0 0 0 3px ${theme.v3.colors.blue}` : undefined};

    margin-right: 17px;

    &:hover {
        cursor: pointer;
        box-shadow:  ${({ theme }) => `0 0 0 3px ${theme.v3.colors.blue}`};
    }

    ${media.custom(360)} {
        width: calc(50% - 18px);
    }

    ${media.custom(514)} {
        width: calc(33.5% - 18px);
    }

    ${media.custom(579)} {
        width: calc(25% - 18px);
    }

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        width: calc(33.5% - 18px);
    }
`;

export const CCImageUploadWrapper = styled.div<{ image?: string }>`
    border: 1px dashed ${({ theme }) => theme.v3.colors.grey88};
    background: ${({ image }) => {
        if (image) return `url(${image}) center center / cover no-repeat`;
    }};
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 117px;

    > div {
        &:first-child {
            margin-right: 24px;
        }
    }
`;

export const CCMEButtons = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
